
CheckoutV2.BraintreePayPalCheckout = function( checkout, options ) {
    "use strict";
    if (!options) 
       options = {
           credit: false,
       };
	if (!options.hasOwnProperty("credit"))
      options['credit'] = false
    
    this.credit = options.credit; 

    this.fundingAllowed = this.credit ? paypal.FUNDING.CREDIT : paypal.FUNDING.CARD;
    this.fundingDisallowed = this.credit ? paypal.FUNDING.CARD : paypal.FUNDING.CREDIT;

    // whether we should send (possibly invalid) shipping adddress to paypal
    // set to false to test previous behavior / error handling
    // or if feature needs reverting
    this.sendShippingAddress = false;

    var totals = checkout.cart.totals;

	this.paypalExpressButton = this.credit ?
		totals.$paypalExpressCreditButton[ 0 ] :
		totals.$paypalExpressButton[ 0 ] ;
	this.paypalExpressWrapper = this.credit ?
		totals.$paypalExpressCreditWrapper :
		totals.$paypalExpressWrapper ;

    this.paypalErrorHandler = function(err) {
        var theError = err.errorMessage || err.message || err;
        var aErrors = theError.split(/\n/);
        theError = aErrors[0] || theError;
        checkout.cart.error();
        checkout.cart.error( "Error loading PayPal Checkout: "+ theError );
        throw( err ); 
    };
    var btpp = this;

    this.renderPaypalExpressButton = function( paypalCheckout ) {
        checkout.cart.error();
        // handle paypal errors, throw message as cart error message


        paypal.Button.render(
            {
                'env'         : checkout.config.braintreePayPalEnvironment,
                'payment'     : function() { return btpp.getExpressPayment( paypalCheckout ) },
                'onAuthorize' : function( data ) {
                    checkout.loading( "Receiving PayPal Payment Details..." );
                    paypalCheckout.tokenizePayment( data ).then( function( payload ) {
                        btpp.setExpressPayment( paypalCheckout, payload );
                    } );
                },
                'onError'     : btpp.paypalErrorHandler,
                'funding'     : {
                    'allowed'    : [ btpp.fundingAllowed ],
                    'disallowed' : [ btpp.fundingDisallowed ],
                },
                'style' : {
                    'color'        : btpp.credit ? 'darkblue' : 'blue',
                    'shape'        : "rect",
                    'fundingIcons' : false,
                    'size'         : "responsive",
                    'layout'       : "horizontal",
                    'tagline'      : false,
                    'label'        : btpp.credit ? 'credit' : "checkout",
                },
            },
            btpp.paypalExpressButton
        )
        .then( function() {
        	if ( !btpp.credit || checkout.config.paypalOfferCreditAmount <= totals.values.total )
            	btpp.paypalExpressWrapper.removeClass( "hide" );
        } );
    };

    this.getExpressPayment = function( paypalCheckout ) {
        var paymentOptions = {
            'amount'                  : totals.values.total,
            'currency'                : "USD",
            'offerCredit'             : btpp.credit,
            'flow'                    : "checkout",
            'intent'                  : "authorize",
            'enableShippingAddress'   : true,
            'shippingAddressEditable' : true,            
            'displayName'             : checkout.config.siteName,
            // ### - fields only used for vaulting
            // 'billingAgreementDescription' : ' '
        };

        // only pass in an address if there is a complete one in the session
        var session = checkout.session.get();
        if ( btpp.sendShippingAddress && session
            && session.shipping
            && session.shipping.address1
            && session.shipping.city
            && session.shipping.state
            && session.shipping.zip
            && session.shipping.country
            ) {
            var shippingAddress = {
                'line1'       : session.shipping.address1,
                'city'        : session.shipping.city,
                'state'       : session.shipping.state,
                'postalCode'  : session.shipping.zip,
                'countryCode' : session.shipping.country,
            };

            if ( session.shipping.address2 ) shippingAddress.line2 = session.shipping.address2;
            if ( session.shipping.phone    ) shippingAddress.phone = session.shipping.phone;

            var nameParts = [];
            if ( session.shipping.firstname ) nameParts.push( session.shipping.firstname );
            if ( session.shipping.lastname  ) nameParts.push( session.shipping.lastname  );
            if ( nameParts.length > 0 ) shippingAddress.recipientName = nameParts.join( " " );

            paymentOptions.shippingAddressOverride = shippingAddress;
        }

		checkout.cart.error();
        if ( window.dataLayer ) {
           var event_name = btpp.credit ? 'braintee-paypal-express-credit-button' : 'braintree-paypal-express-button'
           dataLayer.push({ event: event_name });
        } 
        return paypalCheckout.createPayment( paymentOptions ).catch( btpp.paypalErrorHandler );
    };

    this.setExpressPayment = function( paypalCheckout, payload ) {
        var paymentMethodDetails = {
            'nonce'           : payload.nonce,
            'payerID'         : payload.details.payerId,
            'email'           : payload.details.email,
            'paypalEmail'     : payload.details.email,
            'phone'           : payload.details.phone,
            'first_name'      : payload.details.firstName,
            'last_name'       : payload.details.lastName,
            'shippingAddress' : payload.details.shippingAddress,
            'billingAddress'  : payload.details.billingAddress || payload.details.shippingAddress,
			'paypalCredit'    : true,
        };
        var paymentMethod = checkout.payment.models.paymentMethodFromPaypal(
            paymentMethodDetails,
            totals.values.total
        );
        checkout.payment.setActivePaymentMethods( [ paymentMethod ] );
        checkout.payment.onMethodValid();

        var nameParts = payload.details.shippingAddress.recipientName.split( /\s+/ );
        var firstName = nameParts[ 0 ];
        var lastName = nameParts.slice( 1 ).join( " " );

        checkout.session.set( {
            'email'   : payload.details.email,
            'billing' : {
                'email' : payload.details.email,
            },
            'shipping' : {
                'email'     : payload.details.email,
                'firstname' : firstName,
                'lastname'  : lastName,
                'address1'  : payload.details.shippingAddress.line1,
                'address2'  : payload.details.shippingAddress.line2,
                'city'      : payload.details.shippingAddress.city,
                'state'     : payload.details.shippingAddress.state,
                'zip'       : payload.details.shippingAddress.postalCode,
                'phone'     : payload.details.phone,
            },
        } );

        checkout.shipinfo = new CheckoutV2.ShipInfo(
            checkout,
            ".js-shipping-address .js-address-form.js-shipping"
        );
        checkout.shipinfo.setFormDataFromSession();

        checkout.cart.shipping.init();
        checkout.cart.shipping.calc( true, true );

        totals.$paypalExpressWrapper.hide();
		totals.$paypalExpressCreditWrapper.hide();
        checkout.nextStep( false, 4 );
        checkout.loading( false );
    };
	return btpp;
};

